import React, { Suspense, lazy } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import GitHubConnectCallback from './pages/GitHubConnectCallback';
import ProtectedLayout from './components/layout/ProtectedLayout';
import FullScreenLoader from './components/FullScreenLoader';

const Dashboard = lazy(() => import('./pages/Dashboard'));
const Chat = lazy(() => import('./pages/Chat'));
const Onboarding = lazy(() => import('./pages/Onboarding'));
const MemorySearch = lazy(() => import('./pages/MemorySearch'));
const Tickets = lazy(() => import('./pages/Tickets'));
const IncidentFlows = lazy(() => import('./pages/IncidentFlows'));
const OrganizationSettings = lazy(() => import('./pages/OrganizationSettings'));
const Documents = lazy(() => import('./pages/Documents'));
const GitHub = lazy(() => import('./pages/GitHub'));

const API_BASE = process.env.REACT_APP_BACKEND_URL ?? '';
const API = `${API_BASE}/api`;
export { API };

const ProtectedRoute = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <FullScreenLoader />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/auth/github/connect/callback" element={<GitHubConnectCallback />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<ProtectedLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="chat" element={<Chat />} />
          <Route path="onboarding" element={<Onboarding />} />
          <Route path="memory" element={<MemorySearch />} />
          <Route path="tickets" element={<Tickets />} />
          <Route path="incidents" element={<IncidentFlows />} />
          <Route path="documents" element={<Documents />} />
          <Route path="organization" element={<OrganizationSettings />} />
          <Route path="github">
            <Route index element={<GitHub />} />
            <Route path="repositories/:id" element={<GitHub />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Suspense fallback={<FullScreenLoader />}>
            <AppRoutes />
          </Suspense>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
